// Legal page content (Impressum / Datenschutz / Integritetspolicy)
// DE / EN / SV

const COMPANY = {
  name: "DogCenter Lappland AB",
  rep: "Judith Seel",
  street: "Lyckselevägen 11",
  zip: "921 73",
  city: "Kristineberg",
  country: {
    de: "Schweden",
    en: "Sweden",
    sv: "Sverige",
  },
  email: "info@dogcenter-lappland.se",
};

export const legalContent = {
  de: {
    imprint: {
      title: "Impressum",
      sections: [
        {
          heading: "Angaben gemäß § 5 TMG / 25 kap. ABL",
          body: [
            `${COMPANY.name} (i.gr.)`,
            "Vertreten durch Judith Seel",
            `${COMPANY.street}`,
            `${COMPANY.zip} ${COMPANY.city}, ${COMPANY.country.de}`,
          ],
        },
        {
          heading: "Kontakt",
          body: [`E-Mail: ${COMPANY.email}`],
        },
        {
          heading: "Verantwortlich für den Inhalt",
          body: ["Judith Seel (Anschrift wie oben)"],
        },
        {
          heading: "Unternehmensform",
          body: [
            "Schwedisches Aktiebolag (AB) — in Gründung. Die Gesellschaft befindet sich in der vorbereitenden Phase. Eintragungsdaten werden nach erfolgter Registrierung beim schwedischen Bolagsverket ergänzt.",
          ],
        },
        {
          heading: "Verbraucherstreitbeilegung",
          body: [
            "Wir nehmen nicht an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil und sind dazu auch nicht gesetzlich verpflichtet.",
          ],
        },
        {
          heading: "Haftung für Inhalte",
          body: [
            "Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
          ],
        },
      ],
    },
    privacy: {
      title: "Datenschutzerklärung",
      sections: [
        {
          heading: "1. Verantwortlicher",
          body: [
            `${COMPANY.name} (i.gr.), vertreten durch Judith Seel`,
            `${COMPANY.street}, ${COMPANY.zip} ${COMPANY.city}, ${COMPANY.country.de}`,
            `E-Mail: ${COMPANY.email}`,
          ],
        },
        {
          heading: "2. Erhebung und Verarbeitung personenbezogener Daten",
          body: [
            "Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung dieser Website sowie zur Beantwortung Ihrer Anfragen erforderlich ist (Art. 6 Abs. 1 lit. b und f DSGVO).",
            "• Newsletter-Anmeldung: E-Mail-Adresse und gewählte Sprache. Zweck: Versand von Informationen zum Launch 2026. Rechtsgrundlage: Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die Einwilligung kann jederzeit per E-Mail an info@dogcenter-lappland.se widerrufen werden.",
            "• Kontaktformular: Name, E-Mail-Adresse, Nachricht. Zweck: Bearbeitung Ihrer Anfrage. Rechtsgrundlage: Art. 6 Abs. 1 lit. b und f DSGVO.",
          ],
        },
        {
          heading: "3. Speicherdauer",
          body: [
            "Personenbezogene Daten werden gelöscht, sobald der Zweck der Verarbeitung entfällt und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
          ],
        },
        {
          heading: "4. Ihre Rechte",
          body: [
            "Sie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21 DSGVO). Beschwerden können Sie bei der schwedischen Datenschutzbehörde (Integritetsskyddsmyndigheten, IMY) einreichen.",
          ],
        },
        {
          heading: "5. Cookies, lokale Speicherung & Schriftarten",
          body: [
            "Diese Website verwendet keine Tracking- oder Analyse-Cookies. Technisch notwendige Speicherung (z. B. der gewählten Sprache, Ihrer Bestätigung des Cookie-Hinweises und eines Admin-Login-Tokens) erfolgt ausschließlich lokal in Ihrem Browser (localStorage) und wird nicht an Dritte übermittelt.",
            "Schriftarten (Cormorant Garamond, Manrope, Montserrat) werden direkt von unserem Server geladen. Es findet keine Verbindung zu Google Fonts, Adobe Fonts oder anderen Dritten statt.",
          ],
        },
        {
          heading: "6. Formularverarbeitung & E-Mail-Versand",
          body: [
            "Newsletter- und Kontaktformulare werden direkt auf unseren eigenen Servern verarbeitet und in unserer Datenbank gespeichert. Eine Benachrichtigung wird über unseren E-Mail-Anbieter (mail2.monien.net) an info@dogcenter-lappland.se zugestellt. Rechtsgrundlage: Art. 6 Abs. 1 lit. a (Newsletter, Einwilligung) bzw. Art. 6 Abs. 1 lit. b und f DSGVO (Kontaktformular).",
            "Die Einwilligung zum Newsletter kann jederzeit per E-Mail an info@dogcenter-lappland.se widerrufen werden.",
          ],
        },
        {
          heading: "7. Hosting",
          body: [
            "Die Website wird auf eigenen Servern innerhalb der Europäischen Union gehostet. Es werden keine Daten an Drittländer übermittelt.",
          ],
        },
      ],
    },
  },
  en: {
    imprint: {
      title: "Imprint",
      sections: [
        {
          heading: "Information according to § 5 TMG / ch. 25 ABL",
          body: [
            `${COMPANY.name} (in formation)`,
            "Represented by Judith Seel",
            `${COMPANY.street}`,
            `${COMPANY.zip} ${COMPANY.city}, ${COMPANY.country.en}`,
          ],
        },
        { heading: "Contact", body: [`Email: ${COMPANY.email}`] },
        {
          heading: "Responsible for content",
          body: ["Judith Seel (address as above)"],
        },
        {
          heading: "Legal form",
          body: [
            "Swedish Aktiebolag (AB) — currently in formation. Registration details with Bolagsverket will be added once registration is complete.",
          ],
        },
        {
          heading: "Consumer dispute resolution",
          body: [
            "We do not participate in dispute resolution proceedings before a consumer arbitration board and are not legally obliged to do so.",
          ],
        },
        {
          heading: "Liability for content",
          body: [
            "The contents of this website have been created with the greatest possible care. However, we cannot guarantee the accuracy, completeness or topicality of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws.",
          ],
        },
      ],
    },
    privacy: {
      title: "Privacy Policy",
      sections: [
        {
          heading: "1. Controller",
          body: [
            `${COMPANY.name} (in formation), represented by Judith Seel`,
            `${COMPANY.street}, ${COMPANY.zip} ${COMPANY.city}, ${COMPANY.country.en}`,
            `Email: ${COMPANY.email}`,
          ],
        },
        {
          heading: "2. Collection and processing of personal data",
          body: [
            "We process personal data only as far as it is necessary to provide this website and to respond to your inquiries (Art. 6 (1) lit. b and f GDPR).",
            "• Newsletter signup: email address and selected language. Purpose: sending information about the 2026 launch. Legal basis: consent (Art. 6 (1) lit. a GDPR). Consent can be withdrawn at any time by emailing info@dogcenter-lappland.se.",
            "• Contact form: name, email address, message. Purpose: processing your request. Legal basis: Art. 6 (1) lit. b and f GDPR.",
          ],
        },
        {
          heading: "3. Storage period",
          body: [
            "Personal data will be deleted as soon as the purpose of processing no longer applies and there are no statutory retention obligations.",
          ],
        },
        {
          heading: "4. Your rights",
          body: [
            "You have the right to information (Art. 15), rectification (Art. 16), erasure (Art. 17), restriction of processing (Art. 18), data portability (Art. 20) and objection (Art. 21 GDPR). Complaints can be filed with the Swedish data protection authority (Integritetsskyddsmyndigheten, IMY).",
          ],
        },
        {
          heading: "5. Cookies, local storage & fonts",
          body: [
            "This website does not use tracking or analytics cookies. Technically necessary storage (e.g. the selected language, your cookie notice acknowledgment and an admin login token) is kept locally in your browser (localStorage) and is not transmitted to third parties.",
            "Web fonts (Cormorant Garamond, Manrope, Montserrat) are served directly from our server. No connection is made to Google Fonts, Adobe Fonts or any other third party.",
          ],
        },
        {
          heading: "6. Form processing & email delivery",
          body: [
            "Newsletter and contact forms are processed directly on our own servers and stored in our database. A notification is delivered via our email provider (mail2.monien.net) to info@dogcenter-lappland.se. Legal basis: Art. 6 (1) lit. a (newsletter, consent) and Art. 6 (1) lit. b and f GDPR (contact form).",
            "Newsletter consent can be withdrawn at any time by emailing info@dogcenter-lappland.se.",
          ],
        },
        {
          heading: "7. Hosting",
          body: [
            "The website is hosted on our own servers within the European Union. No data is transferred to third countries.",
          ],
        },
      ],
    },
  },
  sv: {
    imprint: {
      title: "Företagsinformation",
      sections: [
        {
          heading: "Uppgifter enligt 25 kap. ABL / § 5 TMG",
          body: [
            `${COMPANY.name} (under bildande)`,
            "Företräds av Judith Seel",
            `${COMPANY.street}`,
            `${COMPANY.zip} ${COMPANY.city}, ${COMPANY.country.sv}`,
          ],
        },
        { heading: "Kontakt", body: [`E-post: ${COMPANY.email}`] },
        {
          heading: "Ansvarig för innehållet",
          body: ["Judith Seel (adress enligt ovan)"],
        },
        {
          heading: "Bolagsform",
          body: [
            "Svenskt aktiebolag (AB) — under bildande. Registreringsuppgifter hos Bolagsverket kompletteras efter genomförd registrering.",
          ],
        },
        {
          heading: "Tvistlösning för konsumenter",
          body: [
            "Vi deltar inte i tvistlösningsförfaranden inför ett konsumenttvistorgan och är inte heller skyldiga att göra det enligt lag.",
          ],
        },
        {
          heading: "Ansvar för innehållet",
          body: [
            "Innehållet på denna webbplats har skapats med största möjliga omsorg. Vi kan dock inte garantera innehållets riktighet, fullständighet eller aktualitet. Som tjänsteleverantör ansvarar vi för eget innehåll på dessa sidor enligt allmänna lagar.",
          ],
        },
      ],
    },
    privacy: {
      title: "Integritetspolicy",
      sections: [
        {
          heading: "1. Personuppgiftsansvarig",
          body: [
            `${COMPANY.name} (under bildande), företrädd av Judith Seel`,
            `${COMPANY.street}, ${COMPANY.zip} ${COMPANY.city}, ${COMPANY.country.sv}`,
            `E-post: ${COMPANY.email}`,
          ],
        },
        {
          heading: "2. Insamling och behandling av personuppgifter",
          body: [
            "Vi behandlar personuppgifter endast i den utsträckning det är nödvändigt för att tillhandahålla denna webbplats och för att besvara dina förfrågningar (art. 6.1 b och f GDPR).",
            "• Nyhetsbrevsprenumeration: e-postadress och valt språk. Syfte: information om lanseringen 2026. Rättslig grund: samtycke (art. 6.1 a GDPR). Samtycket kan när som helst återkallas via e-post till info@dogcenter-lappland.se.",
            "• Kontaktformulär: namn, e-postadress, meddelande. Syfte: hantering av din förfrågan. Rättslig grund: art. 6.1 b och f GDPR.",
          ],
        },
        {
          heading: "3. Lagringstid",
          body: [
            "Personuppgifter raderas så snart syftet med behandlingen inte längre föreligger och inga lagstadgade lagringskrav hindrar det.",
          ],
        },
        {
          heading: "4. Dina rättigheter",
          body: [
            "Du har rätt till information (art. 15), rättelse (art. 16), radering (art. 17), begränsning av behandling (art. 18), dataportabilitet (art. 20) och invändning (art. 21 GDPR). Klagomål kan lämnas till Integritetsskyddsmyndigheten (IMY).",
          ],
        },
        {
          heading: "5. Kakor, lokal lagring & typsnitt",
          body: [
            "Denna webbplats använder inga spårnings- eller analyskakor. Tekniskt nödvändig lagring (t.ex. det valda språket, din bekräftelse av cookie-meddelandet och en admin-inloggningstoken) sker endast lokalt i din webbläsare (localStorage) och överförs inte till tredje part.",
            "Typsnitt (Cormorant Garamond, Manrope, Montserrat) levereras direkt från vår server. Ingen anslutning görs till Google Fonts, Adobe Fonts eller någon annan tredje part.",
          ],
        },
        {
          heading: "6. Formulärbehandling & e-postutskick",
          body: [
            "Nyhetsbrevs- och kontaktformulär behandlas direkt på våra egna servrar och lagras i vår databas. En notifiering levereras via vår e-postleverantör (mail2.monien.net) till info@dogcenter-lappland.se. Rättslig grund: art. 6.1 a (nyhetsbrev, samtycke) respektive art. 6.1 b och f GDPR (kontaktformulär).",
            "Samtycke till nyhetsbrev kan när som helst återkallas via e-post till info@dogcenter-lappland.se.",
          ],
        },
        {
          heading: "7. Hosting",
          body: [
            "Webbplatsen drivs på våra egna servrar inom Europeiska unionen. Inga uppgifter överförs till tredje land.",
          ],
        },
      ],
    },
  },
};

export const legalUi = {
  de: { close: "Schließen", back: "Zurück", updated: "Stand: Januar 2026" },
  en: { close: "Close", back: "Back", updated: "Last updated: January 2026" },
  sv: { close: "Stäng", back: "Tillbaka", updated: "Senast uppdaterad: januari 2026" },
};
